import axios from 'axios';

export default function getCompanyTags({ uuid }) {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/company/${uuid}/tag`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.data)));
}
